import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export const layoutNameMaxLength = 40;
export const layoutDescriptionMaxLength = 40;

const supportedLayoutFormats = ['CSV', 'TAB', 'TXT', 'HTM'] as const;

/**
 * Name pattern / max length (blank is handled by Validators.required).
 * String errors are shown by core help-text via the custom-string branch.
 */
export function layoutNameConstraintsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const v = typeof control.value === 'string' ? control.value.trim() : '';
    if (!v) {
      return null;
    }
    if (v.length > layoutNameMaxLength) {
      return {
        layoutNameError: 'Layout Name maximum length is 40 characters',
      };
    }
    if (!/^[a-zA-Z0-9_-]+$/.test(v)) {
      return {
        layoutNameError:
          'A query name can only consist of letters, numbers, and dashes, or underscores',
      };
    }
    return null;
  };
}

/** Description max length (blank is handled by Validators.required). */
export function layoutDescriptionConstraintsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const v = typeof control.value === 'string' ? control.value.trim() : '';
    if (!v) {
      return null;
    }
    if (v.length > layoutDescriptionMaxLength) {
      return {
        layoutDescriptionError:
          'Layout Description maximum length is 40 characters',
      };
    }
    return null;
  };
}

export function layoutFormatValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const v = (control.value ?? '').toString().trim().toUpperCase();
    if (
      !v ||
      !supportedLayoutFormats.includes(
        v as (typeof supportedLayoutFormats)[number],
      )
    ) {
      return { layoutFormatError: 'Format is required.' };
    }
    return null;
  };
}

/** First string validation message on a control (for snackbar). */
export function firstStringControlError(control: AbstractControl): string | null {
  if (!control.errors) {
    return null;
  }
  for (const key of Object.keys(control.errors)) {
    if (key === 'required') {
      continue;
    }
    const err = control.errors[key];
    if (typeof err === 'string') {
      return err;
    }
  }
  return null;
}
